import React, { useEffect, memo, useState, Fragment, useRef } from "react";
import AOS from "aos";
import SwiperCore, { Navigation } from "swiper";
import { jwtDecode } from "jwt-decode";
import Chart from "chart.js/auto";
import { useSelector } from "react-redux";
import { Row, Alert, Col, OverlayTrigger, Popover } from "react-bootstrap";
import Card from "../../components/Card";
import Progress from "../../components/progress";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { ImLocation2 } from "react-icons/im";
import { LiaNetworkWiredSolid } from "react-icons/lia";
import { FaWarehouse } from "react-icons/fa";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// Import Swiper styles
import "swiper/swiper-bundle.min.css";
// import 'swiper/components/navigation/navigation.scss';
import url from "../../configs/config";
// Redux Selector / Action
// import Chart from "react-apexcharts";
// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { roleTypes } from "../../data/roleType";
// install Swiper modules
SwiperCore.use([Navigation]);

const dashboardCards = [
  {
    key: "usersCount",
    label: "Users",
    color: "primary",
    bgColor: "rgba(58, 87, 232, 0.1)",
    route: "/dashboard/app/user-list",
    permissionKey: "user",
    icon: (
      <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
        <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
        <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
        <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
        <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
      </svg>
    ),
  },
  {
    key: "warehousesCount",
    label: "Warehouses",
    color: "info",
    bgColor: "rgba(7, 154, 162, 0.1)",
    route: "/dashboard/app/warehouse-list",
    permissionKey: "warehouse",
    icon: <FaWarehouse width="20px" />,
  },
  {
    key: "locationsCount",
    label: "Locations",
    color: "danger",
    bgColor: "rgba(192, 50, 33, 0.1)",
    route: "/dashboard/app/location-list",
    permissionKey: "location",
    icon: <ImLocation2 style={{ width: "20px" }} />,
  },
  {
    key: "vendorsCount",
    label: "Vendors",
    color: "warning",
    bgColor: "rgba(241, 106, 27, 0.1)",
    route: "/dashboard/app/vendor-list",
    permissionKey: "vendor",
    icon: (
      <svg width="20" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fill="none" viewBox="0 0 512 330.845">
        <path fill="currentColor" d="M95.992 0c35.923 22.768 68.373 33.54 96.223 30.995 4.865 98.382-31.466 156.48-95.852 180.727C34.188 189.028-2.587 133.427.142 29.502 32.834 31.213 64.91 24.144 95.992 0zM76.731 103.923a73.156 73.156 0 016.88 6.658c6.723-10.822 13.89-20.757 21.461-29.895 21.401-25.849 11.702-20.867 41.389-20.867l-4.124 4.581c-12.676 14.086-16.952 21.417-27.343 36.429a425.653 425.653 0 00-27.95 46.499l-2.571 4.96-2.363-5.052c-4.359-9.359-9.581-17.95-15.808-25.625-6.228-7.676-11.667-12.684-20.112-18.479 3.87-12.702 22.288-6.201 30.541.791zm301.485 1.74l-35.138-.243V57.97a25.356 25.356 0 00-7.529-18.079 25.353 25.353 0 00-18.079-7.53H213.806c-.435 4.496-1.122 9.147-1.833 13.884H317.47c3.218 0 6.159 1.334 8.278 3.449 2.116 2.12 3.45 5.061 3.45 8.276v217.288H290.06a6.93 6.93 0 00-6.94 6.944 6.925 6.925 0 006.94 6.938h46.077a6.926 6.926 0 006.941-6.938v-7.885h28.044c3.177-72.232 106.9-82.195 117.451 0h22.782c5.868-70.433-28.909-97.805-81.803-103.996-3.805-16.53-11.062-31.874-19.26-47.037-9.747-18.025-12.016-17.297-32.076-17.621zM147.08 275.222a6.929 6.929 0 016.944 6.939 6.93 6.93 0 01-6.944 6.941H73.343c-7.022 0-13.413-3.06-18.082-7.882-4.623-4.821-7.527-11.411-7.527-18.392v-48.35a138.893 138.893 0 0013.881 7.815v40.535c0 3.334 1.375 6.51 3.609 8.824 2.119 2.197 4.98 3.606 8.077 3.606h73.779v-.036zm70.59-38.416c-25.963 0-47.019 21.059-47.019 47.019 0 25.961 21.056 47.02 47.019 47.02 25.961 0 47.017-21.059 47.017-47.02-.038-25.96-21.056-47.019-47.017-47.019zm0 28.942c-9.96 0-18.08 8.08-18.08 18.077 0 9.961 8.08 18.082 18.08 18.082 9.959 0 18.079-8.081 18.079-18.082-.042-9.997-8.12-18.077-18.079-18.077zm212.039-35.86c-25.959 0-47.016 21.059-47.016 47.018 0 25.96 21.057 47.021 47.016 47.021 25.963 0 47.02-21.061 47.02-47.021 0-25.959-21.057-47.018-47.02-47.018zm-18.077 47.018c0 9.961 8.076 18.079 18.077 18.079 10.001 0 18.079-8.077 18.079-18.079 0-9.999-8.078-18.076-18.079-18.076-9.978 0-18.077 8.095-18.077 18.076zm-30.038-151.174l-21.182-.392v45.06h44.866c-5.534-16.073-13.724-30.807-23.684-44.668zM96.049 14.47c30.429 19.287 59.636 30.128 83.227 27.971 4.118 83.335-28.373 134.27-82.908 154.808-52.671-19.224-85.542-68.035-83.23-156.073C43.7 42.778 71.71 33.379 96.049 14.47z" />
      </svg>
    ),
  },
  {
    key: "manufacturersCount",
    label: "Manufacturers",
    color: "danger",
    bgColor: "rgba(192, 50, 33, 0.1)",
    route: "/dashboard/app/manufacturer-list",
    permissionKey: "manufacturer",
    icon: <LiaNetworkWiredSolid style={{ width: "20px" }} />,
  },
  {
    key: "activeProductRequestsCount",
    label: "Active PRs",
    color: "primary",
    bgColor: "rgba(58, 87, 232, 0.1)",
    route: "/dashboard/app/product-request-list",
    permissionKey: "product_request",
    icon: <InventoryIcon style={{ width: "20px" }} />,
  },
  {
    key: "completedProductRequestsCount",
    label: "Completed PRs",
    color: "success",
    bgColor: "rgba(40, 167, 69, 0.1)",
    route: "/dashboard/app/product-request-list",
    permissionKey: "product_request",
    icon: <InventoryIcon style={{ width: "20px" }} />,
  },
  {
    key: "activePurchaseOrdersCount",
    label: "Active POs",
    color: "primary",
    bgColor: "rgba(58, 87, 232, 0.1)",
    route: "/dashboard/app/purchase-order-list",
    permissionKey: "purchase_order",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
        <path d="M8 7h8M8 12h8M8 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M6 7l1 1 2-2M6 12l1 1 2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="6.5" cy="17" r="1" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    key: "completedPurchaseOrdersCount",
    label: "Completed POs",
    color: "success",
    bgColor: "rgba(40, 167, 69, 0.1)",
    route: "/dashboard/app/purchase-order-list",
    permissionKey: "purchase_order",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
        <path d="M8 7h8M8 12h8M8 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M6 7l1 1 2-2M6 12l1 1 2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="6.5" cy="17" r="1" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    key: "stakeholdersCount",
    label: "Stakeholders",
    color: "warning",
    bgColor: "rgba(241, 106, 27, 0.1)",
    route: "/dashboard/app/stakeholder-list",
    permissionKey: "stakeholder",
    icon: <HiBuildingOffice2 style={{ width: "20px" }} />,
  },
  {
    key: "activeJobsCount",
    label: "Active Jobs",
    color: "primary",
    bgColor: "rgba(58, 87, 232, 0.1)",
    route: "/dashboard/app/job-list",
    permissionKey: "job",
    icon: <WorkHistoryIcon style={{ width: "20px" }} />,
  },
  {
    key: "completedJobsCount",
    label: "Completed Jobs",
    color: "success",
    bgColor: "rgba(40, 167, 69, 0.1)",
    route: "/dashboard/app/job-list",
    permissionKey: "job",
    icon: <WorkHistoryIcon style={{ width: "20px" }} />,
  },
];

const DashboardCard = ({
  count,
  label,
  color,
  bgColor,
  route,
  hasPermission,
  navigate,
  icon,
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const targetRef = useRef(null);

  const handleCardClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (hasPermission && route && navigate) {
      navigate(route);
    }
  };

  const handleMouseMove = (e) => {
    if (!hasPermission) {
      setPopoverPosition({ x: e.clientX, y: e.clientY });
      if (!showPopover) {
        setShowPopover(true);
      }
    }
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  const popover = (
    <Popover
      id={`popover-${label}`}
      style={{
        position: "fixed",
        left: `${popoverPosition.x + 15}px`,
        top: `${popoverPosition.y + 15}px`,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Popover.Header as="h3">Access Denied</Popover.Header>
      <Popover.Body>
        You don&apos;t have permission to view {label.toLowerCase()}.
      </Popover.Body>
    </Popover>
  );

  const cardContent = (
    <div
      onClick={handleCardClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      ref={targetRef}
      style={{ height: "100%" }}
    >
      <Card
        className="bg-white position-relative"
        style={{
          overflow: "hidden",
          cursor: hasPermission ? "pointer" : "not-allowed",
          transition: "all 0.3s ease",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: bgColor,
            pointerEvents: "none",
          }}
        />
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center">
            <div className={`bg-soft-${color} rounded p-3`}>
              {icon}
            </div>
            <div className={`text-end text-${color}`}>
              <h2 className="counter">
                <CountUp start={0} end={count || 0} duration={3} />
              </h2>
              {label}
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );

  return (
    <Col lg="3" md="6" className="mb-4">
      {cardContent}
      {!hasPermission && showPopover && popover}
    </Col>
  );
};

const Index = memo((props) => {
  const navigate = useNavigate();
  const alertRef = useRef(null);

  const [alerts, setAlerts] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [decodedToken, setDecodedToken] = useState();
  const [dashboardData, setDashboardData] = useState({});
  const [errors, setErrors] = useState({});
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const token = localStorage.getItem("coyote-token");
  const permissions = useSelector(SettingSelector.set_permissions);
  const isSuperAdmin = decodedToken?.roles?.some(
    (role) => role.role_type === roleTypes.SUPER_ADMIN
  );

  const userRoleTypes = decodedToken?.roles?.map((r) => r.role_type) || [];
  const isAdminRole = userRoleTypes.includes(roleTypes.ADMIN) || userRoleTypes.includes(roleTypes.SUPER_ADMIN);
  const isWarehouse = userRoleTypes.includes(roleTypes.WAREHOUSE);
  const isSupplierOrPurchasing = userRoleTypes.some((r) => [roleTypes.SUPPLIER, roleTypes.PURCHASING].includes(r));
  const restrictPermissions = (isSupplierOrPurchasing || isWarehouse) && !isAdminRole;

  const hasUserViewPermission = permissions?.user?.view === true;
  const hasUserUpdatePermission = permissions?.user?.update === true;
  const hasUserDeletePermission = permissions?.user?.delete === true;
  const hasUserStatusPermission = permissions?.user?.status === true;

  const hasWarehouseViewPermission = permissions?.warehouse?.view === true;
  const hasWarehouseUpdatePermission = permissions?.warehouse?.update === true;
  const hasWarehouseDeletePermission =
    permissions?.warehouse?.view_product_bin === true;
  const hasWarehouseFillProductPermission =
    permissions?.warehouse?.fill_product_into_bin === true;
  const hasWarehouseWarehoseProductPermission =
    permissions?.warehouse?.view_warehouse_product === true;
  const hasWarehouseImportProductPermission =
    permissions?.warehouse?.import_product === true;
  const hasWarehouseStatusPermission = permissions?.warehouse?.status === true;

  const hasLocationViewPermission = permissions?.location?.view === true;
  const hasLocationUpdatePermission = permissions?.location?.update === true;
  const hasLocationDeletePermission = permissions?.location?.delete === true;
  const hasLocationStatusPermission = permissions?.location?.status === true;

  const hasVendorViewPermission = permissions?.vendor?.view === true;
  const hasVendorUpdatePermission = permissions?.vendor?.update === true;
  const hasVendorDeletePermission = permissions?.vendor?.delete === true;
  const hasVendorStatusPermission = permissions?.vendor?.status === true;

  const hasManufacturerViewPermission =
    permissions?.manufacturer?.view === true;
  const hasManufacturerUpdatePermission =
    permissions?.manufacturer?.update === true;
  const hasManufacturerDeletePermission =
    permissions?.manufacturer?.delete === true;
  const hasManufacturerStatusPermission =
    permissions?.manufacturer?.status === true;

  const hasProductRequestViewPermission =
    permissions?.product_request?.view === true;
  const hasProductRequestUpdatePermission =
    permissions?.product_request?.update === true;
  const hasProductRequestDeletePermission =
    permissions?.product_request?.delete === true;
  const hasProductRequestStatusPermission =
    permissions?.product_request?.status === true;

  const hasPurchaseOrderViewPermission =
    permissions?.purchase_order?.view === true;
  const hasPurchaseOrderUpdatePermission =
    permissions?.purchase_order?.update === true;
  const hasPurchaseOrderDeletePermission =
    permissions?.purchase_order?.delete === true;
  const hasPurchaseOrderStatusPermission =
    permissions?.purchase_order?.status === true;

  const hasStakeholderViewPermission = permissions?.stakeholder?.view === true;
  const hasStakeholderUpdatePermission =
    permissions?.stakeholder?.update === true;
  const hasStakeholderDeletePermission =
    permissions?.stakeholder?.delete === true;
  const hasStakeholderStatusPermission =
    permissions?.stakeholder?.status === true;
  const hasStakeholderDeleteContactPermission =
    permissions?.stakeholder?.delete_contact === true;

  const hasJobViewPermission = permissions?.job?.view === true;
  const hasJobUpdatePermission = permissions?.job?.update === true;
  const hasJobDeletePermission = permissions?.job?.delete === true;
  const hasJobStatusPermission = permissions?.job?.status === true;
  const hasJobDownloadReportPermission =
    permissions?.job?.download_reports === true;
  const hasJobViewJobProductReportPermission =
    permissions?.job?.view_job_product_report === true;
  const hasJobUpdateJobItemStatusPermission =
    permissions?.job?.update_job_item_status === true;
  const hasJobCreateBomPermission = permissions?.job?.create_bom === true;
  const hasJobViewBomPermission = permissions?.job?.view_bom === true;
  const hasJobDeleteBomPermission = permissions?.job?.delete_bom === true;
  const hasJobEditBomPermission = permissions?.job?.edit_bom === true;
  const hasJobCreateBomPrPermission = permissions?.job?.create_bom_pr === true;
  const hasJobPrintBomPermission = permissions?.job?.print_bom === true;

  const checkPermission = (permissionKey) => {
    if (isSuperAdmin) {
      return true;
    }

    const permissionMap = {
      user:
        hasUserViewPermission ||
        hasUserUpdatePermission ||
        hasUserDeletePermission ||
        hasUserStatusPermission,
      warehouse:
        hasWarehouseViewPermission ||
        hasWarehouseUpdatePermission ||
        hasWarehouseDeletePermission ||
        hasWarehouseFillProductPermission ||
        hasWarehouseWarehoseProductPermission ||
        hasWarehouseImportProductPermission ||
        hasWarehouseStatusPermission,
      location:
        hasLocationViewPermission ||
        hasLocationUpdatePermission ||
        hasLocationDeletePermission ||
        hasLocationStatusPermission,
      vendor:
        hasVendorViewPermission ||
        hasVendorUpdatePermission ||
        hasVendorDeletePermission ||
        hasVendorStatusPermission,
      manufacturer:
        hasManufacturerViewPermission ||
        hasManufacturerUpdatePermission ||
        hasManufacturerDeletePermission ||
        hasManufacturerStatusPermission,
      product_request:
        hasProductRequestViewPermission ||
        hasProductRequestUpdatePermission ||
        hasProductRequestDeletePermission ||
        hasProductRequestStatusPermission,
      purchase_order:
        hasPurchaseOrderViewPermission ||
        hasPurchaseOrderUpdatePermission ||
        hasPurchaseOrderDeletePermission ||
        hasPurchaseOrderStatusPermission,
      stakeholder:
        hasStakeholderViewPermission ||
        hasStakeholderUpdatePermission ||
        hasStakeholderDeletePermission ||
        hasStakeholderStatusPermission ||
        hasStakeholderDeleteContactPermission,
      job:
        hasJobViewPermission ||
        hasJobUpdatePermission ||
        hasJobDeletePermission ||
        hasJobStatusPermission ||
        hasJobDownloadReportPermission ||
        hasJobViewJobProductReportPermission ||
        hasJobUpdateJobItemStatusPermission ||
        hasJobCreateBomPermission ||
        hasJobViewBomPermission ||
        hasJobDeleteBomPermission ||
        hasJobEditBomPermission ||
        hasJobCreateBomPrPermission ||
        hasJobPrintBomPermission,
    };
    return permissionMap[permissionKey] || false;
  };

  const isVisible = (permissionKey) => {
    if (isAdminRole) {
      return true;
    }
    if (isSupplierOrPurchasing || isWarehouse) {
      return checkPermission(permissionKey);
    }
    return true;
  };

  useSelector(SettingSelector.theme_color);
  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];

  useEffect(() => {
    return () => colors;
  });

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });

  useEffect(() => {
    if (typeof token === "string" && token.trim() !== "") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    } else {
      console.error("Invalid token specified: must be a non-empty string");
    }
  }, [token]);

  const getDashboard = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    }


    if (token) {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      try {
        const response = await axios.get(`${url.backendURL}dashboard/`, config);
        setDashboardData(response.data.response.data);
      } catch (err) {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        handleError(err, "dashboard");
      }
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;

    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlerts({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlerts({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  useEffect(() => {
    if (decodedToken) {
      getDashboard();
    }
  }, [decodedToken]);

  return (
    <>
      {showAlertSuccess && (
        <div
          className="bd-example fixed"
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            minWidth: "320px",
            zIndex: "1111",
          }}
        >
          <Alert variant="success d-flex align-items-center" role="alert">
            <svg
              className="me-2"
              id="check-circle-fill"
              width="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
            </svg>
            <div>{alertMessage}</div>
            {"   "}
            <button
              type="button"
              className="btn-close ms-auto"
              data-bs-dismiss="alert"
              aria-label="Close"
              onClick={() => setShowAlertSuccess(false)}
            ></button>
          </Alert>
        </div>
      )}

      {showAlertError && (
        <div
          className="bd-example fixed"
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            minWidth: "320px",
            zIndex: "11111",
          }}
        >
          <Alert variant="danger d-flex align-items-center" role="alert">
            <svg
              className="me-2"
              id="exclamation-triangle-fill"
              fill="currentColor"
              width="20"
              viewBox="0 0 16 16"
            >
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
            </svg>
            <div>{alertMessage}</div> {"   "}
            <button
              type="button"
              className="btn-close ms-auto"
              data-bs-dismiss="alert"
              aria-label="Close"
              onClick={() => setShowAlertError(false)}
            ></button>
          </Alert>
        </div>
      )}
      {token && decodedToken && (
        <Fragment>
          <Row>
            {dashboardCards
              .filter((card) => isVisible(card.permissionKey))
              .map((card) => (
                <DashboardCard
                  key={card.key}
                  count={dashboardData[card.key]}
                  label={card.label}
                  color={card.color}
                  bgColor={card.bgColor}
                  route={card.key === "usersCount" && isWarehouse && !isAdminRole ? "/dashboard/app/warehouse/user-list" : card.route}
                  hasPermission={checkPermission(card.permissionKey)}
                  navigate={navigate}
                  icon={card.icon}
                />
              ))}
          </Row>
        </Fragment>
      )}
    </>
  );
});

export default Index;
